module.exports = __webpack_public_path__ + "static/media/mtto_oficinas.ee5b47a7.svg";